import {computed, inject, Injector} from '@angular/core';
import {toObservable} from '@angular/core/rxjs-interop';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {filter, take} from 'rxjs';
import {PermissionId} from '../../api';
import {CurrentUserService} from '../services/current-user.service';

const hasPermission = (permission: PermissionId): CanActivateFn => () => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);
  const injector = inject(Injector);

  const result = computed<boolean | UrlTree | null>(() => {
    if (currentUserService.userQuery.isPending()) return null;
    const user = currentUserService.currentUser();
    if (!user) return router.createUrlTree(['/']);
    return user.permissionIds.includes(permission) || router.createUrlTree(['/']);
  });

  return toObservable(result, {injector}).pipe(
    filter((v): v is boolean | UrlTree => v !== null),
    take(1)
  );
};

export const financesGuard = hasPermission(PermissionId.CanAccessFinances);
export const peppolGuard = hasPermission(PermissionId.CanAccessPeppol);
export const permissionsManagementGuard = hasPermission(PermissionId.CanManagePermissions);
export const licenceServerGuard = hasPermission(PermissionId.CanManageLicenceServer);
export const productGuard = hasPermission(PermissionId.CanManageProduct);
export const customerProductGuard = hasPermission(PermissionId.CanManageCustomerProducts);
export const settingsGuard = hasPermission(PermissionId.CanAccessSettings);
export const documentGuard = hasPermission(PermissionId.CanAccessDocument);
export const timesheetGuard = hasPermission(PermissionId.CanAccessTimesheet);
export const todoGuard = hasPermission(PermissionId.CanAccessTodo);
export const userManagementGuard = hasPermission(PermissionId.CanManageUser);
